<template>
  <section class="thing-first-level"
           :class="{ 'project-things': $route.name === 'projectItem.project-edit-item' }"
  >
    <ul class="things-list">
      <li class="things-item legend-item item-assigned">
        <div class="cell1 " v-if="!journalsPages && !journalMultithingPage">
          <button type="button"
                  :class="{'check-all_active': allChecked}"
                  @click="checkAll"
                  class="check-all ">
          </button>
        </div>
        <div class="cell2 legend"
             :class="{'legend-active': nameActive}"
             @click="changeFilterToName">
          {{$t('things.thingName')}}
<!--          v-if="legendItem.legendSort"-->
          <filer-icon :up="nameUp || IDActive || typeActive"
                      :down="nameDown || IDActive || typeActive"></filer-icon>
        </div>
        <div class="cell3 legend"
             :class="{'legend-active': IDActive}"
             @click="changeFilterToID">
          {{$t('things.idThing')}}
          <filer-icon :up="IDUp || typeActive || nameActive"
                      :down="IDDown || typeActive || nameActive"></filer-icon>
        </div>
        <div class="cell4 legend">
          {{$t('labels.owner')}}
        </div>
        <div  class="cell-hidden legend">
          {{$t('labels.rights')}}
        </div>
        <div class="cell5 legend"
             :class="{'legend-active': typeActive}"

             @click="changeFilterToType">
          {{$t('labels.type')}}
          <filer-icon :up="typeUp || nameActive || IDActive"
                      :down="typeDown || nameActive || IDActive"></filer-icon>
        </div>
        <div class="cell6"></div>
      </li>
      <li class="things-item item-assigned"
          :draggable="item.permission_level < 2 || disableDragNDrop ? false : true"
          v-for="(item) in activateFilter"
          @dragstart="dragStart(item, $event, drugConfig)"
          @mousedown="setDelta"
          @dblclick="goTo(item)"
          :class="{'things-dropzone things-group': isVirtual(item) || isGroup(item),
           'item-blocked item-blocked-thing': item.permission_level < 2 || disableDragNDrop,
           }"
          :ref="'thing' + item.id"
          :data-group="(isGroup(item) || isVirtual(item)) ? item.id : null"
          :data-type="item.type"
          :key="item.id">
        <div class="cell1" v-if="!journalsPages && !journalMultithingPage" :class="{'item-blocked': item.permission_level < 2 || disableDragNDrop}">
          <label :class="{'check-cont_warning': item.permission_level < 3 || disableCheck}"
                 class="check-cont_small check-cont disable-drug check-cont_opacity">
            <input type="checkbox"
                   v-model="checkedItems"
                   :disabled="item.owner.user.primary_role_id !== user.primary_role_id && $route.name !== 'projectItem.project-edit-item' && $route.name !== 'project-edit'"
                   @change="checkItem"
                   :value="item"
                   class="disable-drug"
                   name="check-thing">
            <p class="check-label disable-drug"></p>
          </label>
        </div>
        <div class="cell2"
             :class="{'item-blocked': item.permission_level < 2 || disableDragNDrop}">
          <thing-icon v-if="item.virtual"></thing-icon>
          <virtual-icon v-if="!item.virtual"></virtual-icon>
<!--          <group-icon v-if="isGroup(item)"></group-icon>-->
          <!--{{trimString(item.name, 20)}}-->
          <trim-item :string="item.name" :offset="75" :width="widthName"></trim-item>
        </div>
        <div class="cell3"
             :class="{'item-blocked': item.permission_level < 2}">
          {{item.id}}
        </div>

<!--        <div class="cell4" :class="{'item-blocked': item.permission_level < 2}">-->
<!--          <div class="avatar-cont"-->
<!--               :style="{backgroundImage: 'url(' + projectOwner(item.owner_role_id).user.contacts.avatar_url + ')'}">-->
<!--            <user-icon v-if="!projectOwner(item.owner_role_id).user.contacts.avatar_url"></user-icon>-->
<!--          </div>-->
<!--          {{projectOwner(item.owner_role_id).user.first_name}} {{projectOwner(item.owner_role_id).user.second_name}}-->
<!--        </div>-->

        <div class="cell4" :class="{'item-blocked': item.permission_level < 2}">
          <div class="avatar-cont"
               :style="{backgroundImage: `url('${item.owner.user.contacts.avatar_url}')`}"
          >
            <user-icon v-if="!item.owner.user.contacts.avatar_url || item.owner.user.contacts.avatar_url === ''"></user-icon>
          </div>
          <span>{{item.owner.user.first_name}}</span><span style="margin-left: 4px" v-if="item.owner.user.second_name">{{item.owner.user.second_name}}</span>
        </div>
<!--        <div v-else class="cell4" :class="{'item-blocked': item.permission_level < 2}">-->
<!--          <div class="avatar-cont"-->
<!--               :style="{backgroundImage: 'url(' + projectOwner(item.owner_role_id).user.contacts.avatar_url + ')'}">-->
<!--            <user-icon v-if="!projectOwner(item.owner_role_id).user.contacts.avatar_url"></user-icon>-->
<!--          </div>-->
<!--          {{projectOwner(item.owner_role_id).user.first_name}}<span style="margin-left: 4px" v-if="projectOwner(item.owner_role_id).user.second_name">{{projectOwner(item.owner_role_id).user.second_name}}</span>-->
<!--        </div>-->
        <div :class="{'hint-cont': item.permission_level > 2}"
             class="cell-hidden">
<!--          <span v-if="item.permission_level > 2">{{trimString(returnPermission(item.permission_level), 23)}}</span>-->
          <span>{{adminPermission}}</span>
<!--          <span v-else>{{returnPermission(item.permission_level)}}</span>-->
<!--          <p class="btn-hint_bottom btn-hint">{{returnPermission(item.permission_level)}}</p>-->
        </div>
        <div class="cell5" :class="{'item-blocked': item.permission_level < 2}">
<!--          {{setType(item.type)}}-->
          {{item.virtual ?  multiThingName : thingName}}
        </div>
        <div class='cell6 edit-btn'>
          <button type="button" @click="goTo(item, 'multi')" class="edit-btn disable-drug">
            <journal-icon v-if="checkRouteName()"
                          class="w14"></journal-icon>
            <gear-icon v-else class="edit-btn disable-drug"></gear-icon>
          </button>
        </div>
      </li>

      <li class="hidden-element things-item item-assigned"
          v-for="(draggedElItem, draggedElItemIndex) in draggedEl"
          :key="'hidden' + draggedElItem.id"
          ref="hiddenEl"
          :style="{left: `${multiDragXY[draggedElItemIndex].dragX}px`, top:  `${multiDragXY[draggedElItemIndex].dragY}px`, visibility: hiddenEl ? 'hidden': 'visible'}"
          @mouseup="dragEnd(draggedElItem, $event, drugConfig)"
          v-if="draggedEl && multiDragXY && multiDragXY.length > 0 && multiDragXY[0].dragX">
        <div class="cell1">
          <label class="check-cont_small check-cont disable-drug check-cont_opacity">
            <input type="checkbox"
                   class="disable-drug"
                   name="check-thing">
            <p class="check-label disable-drug"></p>
          </label>
        </div>
        <div class="cell2">
          <thing-icon v-if="isVirtual(draggedElItem)"></thing-icon>
          <virtual-icon v-if="isThing(draggedElItem)"></virtual-icon>
          <group-icon v-if="isGroup(draggedElItem)"></group-icon>
          {{trimString(draggedElItem.name, 20)}}
        </div>
        <div class="cell3">
          {{draggedElItem.id}}
        </div>
        <div v-if="isThingsPage || isVirtualPage || journalsPage" class="cell4">
          <div class="avatar-cont"
               :style="{backgroundImage: `url('${adminAvatar}')`}"
          >
            <user-icon v-if="!adminAvatar || adminAvatar === ''"></user-icon>
          </div>
          {{adminName}} {{adminSurname}}
        </div>
        <div v-else class="cell4">
          <div class="avatar-cont"
               :style="{backgroundImage: 'url(' + projectOwner(draggedElItem.owner_role_id).user.contacts.avatar_url + ')'}">
          </div>
          {{projectOwner(draggedElItem.owner_role_id).user.first_name}} <span v-if="projectOwner(draggedElItem.owner_role_id).user.second_name">{{projectOwner(draggedElItem.owner_role_id).user.second_name}}</span>
        </div>
        <!--<div
             class="cell-hidden">
          {{returnPermission(draggedEl.permission_level)}}
        </div>-->
        <div class="cell5">
          {{setType(draggedElItem.type)}}
        </div>
        <div class='cell6 edit-btn'>
          <button type="button" class="edit-btn disable-drug">
            <gear-icon class="edit-btn disable-drug"></gear-icon>
          </button>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
  import {mapState,mapGetters,mapMutations,mapActions} from 'vuex'
  import {filters} from "../../../../mixins/filters";
  import {getThingsFromTree} from "../../../../mixins/things/getThingsFromTree";
  import thingIcon from '../../../Svg/things/thingIcon'
  import virtualIcon from '../../../Svg/things/virtualIcon'
  import groupIcon from '../../../Svg/things/groupIcon'
  import gearIcon from '../../../Svg/gearIcon'
  import userIcon from '../../../Svg/users/user'
  import {checkedClass} from "../../../../mixins/utils/checkedClass";
  import {drugNdrop} from "../../../../mixins/dragNdrop/drugNdrop";
  import {combineThings} from "../../../../mixins/things/combineThings";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";
  import trimItem from '../../../trimITem'
  import {sidebarState} from "../../../../mixins/utils/sidebarState";
  import {showOverlay} from "../../../../mixins/utils/showOverlay";
  import filerIcon from '../../../Svg/filterIcon'
  import journalIcon from '../../../Svg/dashboard/journalIcon'

  export default {
    name: 'thingsFirstLevel',
    mixins: [filters,getThingsFromTree,checkedClass,drugNdrop, combineThings, loaderMixin, sidebarState, showOverlay],
    components: {
      thingIcon,
      virtualIcon,
      groupIcon,
      gearIcon,
      trimItem,
      userIcon,
      filerIcon,
      journalIcon
    },
    props: {
      disableDragNDrop: {
        type: Boolean,
        default: false
      },
      disableCheck: {
        type: Boolean,
        default: false
      },
      journalsPages: {
        type: Boolean,
        default: false
      },
      journalsPage: {
        type: Boolean,
        default: false
      },
      journalMultithingPage: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        allThingsInProjectArr: [],
        all_thingsMerge: [],
        checkedItems: [],
        thingName: this.$t('things.thing'),
        multiThingName: this.$t('things.thingMulti'),
        isThings: true,
        drugConfig: {
          refName: 'thing',
          fullX: 540,
          closedX: 360,
          y: 90,
          dropzone: '.things-dropzone',
          dropActive: 'things-drop',
          attr: 'data-group',
          groupClass: 'things-group',

        },
        widthName: 1,
        adminPermission: '',
        adminName: '',
        adminSurname: '',
        adminAvatar: '',
        adminID: '',
        typeOfThing: '',

        //для фильтрации по имени вещи
        nameActive: true,
        nameDown: true,
        nameUp: false,

        //для фильтрации по айди вещи
        IDActive: false,
        IDDown: true,
        IDUp: false,

        //для фильтрации по типу вещи
        typeActive: false,
        typeDown: true,
        typeUp: false,

        //временный массиы для функции фильтрации
        newArr: [],
        ownersChecked: []
      }
    },
    computed: {
      ...mapState({
        checkedThingsStore: state => state.things.checkedThingList,
        group: state => state.things.device,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned,
        activeThingsTags: state => state.things.activeThingsTags,
        nameProfile: state => state.profile.name,
        surnameProfile: state => state.profile.surname,
        avatarProfile: state => state.profile.avatar,
        user: state => state.auth.user,
        displayedNowThings: state => state.things.displayedNowThings,
      }),
      ...mapGetters({
        thingsFirstData: 'things/firstLevelThings',
        projectOwnerRole: 'projects/projectOwnerRole',
        adminRole: 'projects/adminRole',
        isAdminRole: 'auth/adminRole',
      }),
      isVirtualPage() {
        return this.$route.name === 'virtualThingList'
      },
      isThingsPage() {
        return this.$route.name === 'things'
      },
      isThingsInProjectPage() {
        return this.$route.name === 'ThingsInProject'
      },
      isThingsInProjectItemPage() {
        return this.$route.name === 'ThingsInProjectItem'
      },
      isProjectEditPage() {
        return this.$route.name === 'project-edit'
      },
      isProjectItemEditPage() {
        return this.$route.name === 'projectItem.project-edit-item'
      },
      allThingsInProject() {
        let allThingsInProjectArr = []
        let all_thingsMerge = []
        let projectFunc = (data) => {
          data.forEach((item) => {
            if (item.devices.length > 0) {
              item.devices.forEach((device) => {
                allThingsInProjectArr.push(device)
              })
            }
            if (item.items.length > 0) {
              projectFunc(item.items)
            }
          })
        }
        this.projects.forEach((project) => {
          if (project.devices) {
            project.devices.forEach((device) => {
              allThingsInProjectArr.push(device)
            })
          }
          if (project.items.length > 0) {
            projectFunc(project.items)
          }
        })
        if (this.user.primary_role_id === this.user.active_role_id) {
          allThingsInProjectArr = allThingsInProjectArr.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set)); //удаляет дубли из allThingsInProjectArr, если есть

          all_thingsMerge = allThingsInProjectArr.concat(this.allThingsFromGetOwned.filter(item => !item.parent_device_id))
          let spliceFunc = () => {
            all_thingsMerge.forEach((allProject, allProjectIndex) => {
              if (allProjectIndex > allThingsInProjectArr.length - 1) {
                allThingsInProjectArr.forEach((project) => {
                  if (allProject.id === project.id) {
                    all_thingsMerge.splice(allProjectIndex, 1)
                    spliceFunc();
                  }
                })
              }
            })
          }
          spliceFunc()
        } else {
          all_thingsMerge = allThingsInProjectArr
        }
        return all_thingsMerge
      },
      thingsFirst() {
        let all_things = [];
        if(this.isThingsPage || this.journalsPage) {
          // all_things = this.allThingsFromGetOwned.filter(item => !item.parent_device_id);
          all_things = this.allThingsInProject
        } else if(this.routeId) {
          if (!this.isVirtualPage && !this.journalMultithingPage) {
            all_things = this.allDevices;
          } else {
            if (this.journalMultithingPage) {
              this.allThingsFromGetOwned.forEach((item) => {
                // console.log('item' , item)
                if (Number(item.id) === Number(this.routeId)) {
                  all_things = item.devices
                }
              })
            } else {
              all_things = this.returnFirstLevleVirtual(this.group)
            }
          }
        };

        let thingsArr = ((!this.activeThingsTags || this.activeThingsTags.length == 0) ? all_things : all_things.filter(item => {
          for(let i = 0; i < this.activeThingsTags.length; i++) {
            for (let x = 0; x < item.tags.length; x++) {
              if(item.tags[x].id == this.activeThingsTags[i].id) {
                return true;
              }
            }
          }

          return false;
        }));

        thingsArr.sort((a,b) => {
          if ((a.type == 'group' && (b.type == 'thing' || b.type == 'virtual') || (a.type == 'thing' && b.type == 'virtual'))) {
            return -1
          };

          if ((b.type == 'group' && (a.type == 'thing' || a.type == 'virtual') || (b.type == 'thing' && a.type == 'virtual'))) {
            return 1
          }

          return 0
        });

        this.setDisplayedNowThings(thingsArr)

        return thingsArr
      },
      activateFilter() {
        if (this.thingsFirst) {
          this.newArr = this.thingsFirst.slice()

          this.newArr = this.newArr.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set)); //удаляем дубли по id в массиве

          //фильтр по имени (изначально тру)
          if (this.nameActive) {
            this.newArr.sort((a, b) => {
              let nameA = a.name;
              let nameB = b.name

              if (this.nameDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              }
              ;
              if (this.nameUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          }

          //фильтр по айди
          if (this.IDActive) {
            this.newArr.sort((a, b) => {
              let nameA = a.id;
              let nameB = b.id

              if (this.IDDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              }
              ;
              if (this.IDUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          }

          //фильтр по типу вещи
          if (this.typeActive) {
            this.newArr.sort((a, b) => {
              let nameA = a.virtual;
              let nameB = b.virtual

              if (this.typeDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              }
              ;
              if (this.typeUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          }
        }
        // console.log('new arr', this.newArr)
        // console.log('user', this.user)
        return this.newArr
      },
      checkedThings: {
        get() {
          // this.checkedThingsStore = this.checkedThingsStore.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set));
          return this.checkedThingsStore
        },
        set(val) {
          this.setChecked(val);
        }
      },
      allChecked() {
        let arr = [];

        if (this.$route.name === 'projectItem.project-edit-item' || this.$route.name === 'project-edit') {
          arr = [ ...this.activateFilter ]
        } else {
          this.activateFilter.forEach((item) => {
            if (item.owner.user.primary_role_id === this.user.primary_role_id) {
              arr.push(item)
            }
          })
        }

        if (arr.length === this.checkedItems.length && this.checkedItems.length > 0) return true
      },
      isAssigned() {
        let marker = false;
        for (let i = 0; i < this.thingsFirst.length; i++) {
          if (!this.thingsFirst[i].permissions) {
            marker = true;
            break;
          }
        };
        return marker
      }
    },
    watch: {
      routeId(val) {
        this.setChecked([]);
      },
      routeItem(val) {
        this.setChecked([]);
      },
      checkedThings(val) {
        if (val.length === 0) {
          this.checkedItems = [];
        }
      },
      allThingsFromGetOwned() {
        this.setAdminRole()
      },
      checkedThingsStore(val) {
        if (val.length === 0) {
          this.checkedItems = []
        }
        this.checkedItems = this.checkedThings
      },
    },
    methods: {
      ...mapMutations({
        setChecked: 'things/SET_CHECKED_THINGS_LIST',
        showErrorMerge: 'things/SET_ERROR_MERGE_THING',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setDisplayedNowThings: 'things/SET_DISPLAYED_NOW_THINGS',
      }),
      changeFilterToName() {
        this.IDActive = false
        this.typeActive = false

        if (this.nameActive) {
          this.nameDown = !this.nameDown
          this.nameUp = !this.nameUp
        };
        this.nameActive = true
      },
      changeFilterToID() {
        this.nameActive = false
        this.typeActive = false

        if (this.IDActive) {
          this.IDDown = !this.IDDown
          this.IDUp = !this.IDUp
        }
        this.IDActive = true
      },
      changeFilterToType() {
        this.nameActive = false
        this.IDActive = false

        if (this.typeActive) {
          this.typeDown = !this.typeDown
          this.typeUp = !this.typeUp
        }
        this.typeActive = true
      },
      setAdminRole() {
        this.adminRole.filter(item => {
          if(item.name === "Администратор") {
            this.adminPermission = this.$t('things.ownerTitle')
            this.adminID = item.id
            this.adminName = this.nameProfile
            this.adminSurname = this.surnameProfile
            this.adminAvatar = this.avatarProfile
          }
        })
      },
      projectOwner(id) {
        return this.projectOwnerRole(id)
      },
      async dragEnd(item) {
        let elems = document.querySelectorAll('.moved_class-opacity')

        if (elems) {
          elems.forEach((item) => {
            item.classList.remove('moved_class-opacity');
          })
        };
        this.deltaY = '';
        this.deltaX = '';
        this.dragX = '';
        this.dragY = '';
        this.multiDragXY = [];

        document.removeEventListener('mousemove', this.mouseMove);

        if (this.movedGroup) {
          let groupItem;

          for (let i = 0; i < this.thingsFirst.length; i++) {
            let item = this.thingsFirst[i];
            if (this.movedGroup == item.id) {
              groupItem = item;
              break;
            }
          };
          if (groupItem) {
            //не разрешаем класть группу в виртуальную вещь
            //и что либо в вещь
            if (this.isVirtual(groupItem) && this.isGroup(item) || this.isThing(groupItem)) {
              return;
            };
            //перетаскиваем вещь
            this.showLoader();
            if (this.isThing(item) || this.isVirtual(item)) {
              //в группу
              /*if (this.isGroup(groupItem)) {
                await this.updateThingMerged(this.movedGroup, item).catch(e => {
                  if (e.message === 'stop') {
                    return
                  }
                })
              };*/

              //в мультивещь
              if (this.isVirtual(groupItem)) {
                await this.updateVirtualMerged(this.movedGroup, item, groupItem);
              };
            };

            //перетаскиваем группу
            /*if (this.isGroup(item)) {
              //в группу
              if (this.isGroup(groupItem)) {
                await this.updateGroupMerged(this.movedGroup, item);
              }
            };*/
            await this.updateThings().then(() => {
              this.clearAll();
              this.hideLoader();
            })
          }
        };
        this.leaveGroup();
      },
      returnPermission(val) {
        switch (val) {
          case(1): return this.$t('things.per1');
            break;
          case(2): return `${this.$t('things.per1')}, ${this.$t('things.per2')}`
            break;
          case(3): return `${this.$t('things.per1')}, ${this.$t('things.per2')}, ${this.$t('things.per3')}`
            break;
          case(4): return `${this.$t('things.per4')}`
        }
      },
      checkRouteName() {
        if(this.$route.name === 'journal' ||
          this.$route.name === 'journalMultithingInProject' ||
          this.$route.name === 'journalThingsInProject' ||
          this.$route.name === 'journalThingsInProjectItem') {
          return true
        } else {
          return false
        }
      },
      /*returnFirstLevelGroup(group) {
        let arr = [];
        if (group && group.groups && group.devices) {
          group.groups.forEach(item => {
            item.type = 'group';
            arr.push(item);
          });

          group.devices.forEach(item => {
            if (item.virtual) {
              item.type = 'virtual'
            } else {
              item.type = 'thing'
            }
            ;
            arr.push(item)
          });
        }
        return arr.sort((a,b) => {
          if ((a.type == 'group' && (b.type == 'thing' || b.type == 'virtual') || (a.type == 'thing' && b.type == 'virtual'))) {
            return -1
          };

          if ((b.type == 'group' && (a.type == 'thing' || a.type == 'virtual') || (b.type == 'thing' && a.type == 'virtual'))) {
            return 1
          }

          return 0
        })
      },*/
      returnFirstLevleVirtual(thing) {
        let arr = [];
        if (thing && thing.devices) {
          thing.devices.forEach(item => {
            if (item.virtual) {
              item.type = 'virtual'
            } else {
              item.type = 'thing'
            };
            arr.push(item);
          })
        };
        return arr.sort((a,b) => {
          if (a.type == 'virtual' && b.type == 'thing') {
            return -1
          };

          if (a.type == 'thing' && b.type == 'virtual') {
            return 1
          };

          return 0;
        })
      },
      isThing(item) {
        //return item.type === 'thing'
        return item.virtual === false
      },
      isVirtual(item) {
        //return item.type === 'virtual'
        return item.virtual === true
      },
      isGroup(item) {
        return item.type === 'group'
      },
      checkItem(e) {
        let arr = this.checkedItems.slice()
        this.checkedThings = arr;
        this.setChecked(this.checkedThings);
        let input = e.target;
        let item = input.parentElement.parentElement.parentElement;
      },
      checkAll() {
        if (!this.allChecked) {
          this.checkedItems = this.activateFilter

          this.ownersChecked = []
          if (this.$route.name === 'projectItem.project-edit-item' || this.$route.name === 'project-edit') {
            this.checkedItems.forEach(item => {
              this.ownersChecked.push(item)
              this.checkedItems = this.ownersChecked
              this.setChecked(this.ownersChecked)
            })
          } else {
            this.checkedItems.forEach(item => {
              if (item.owner.user.primary_role_id === this.user.primary_role_id) {
                this.ownersChecked.push(item)
              }
              this.checkedItems = this.ownersChecked
              this.setChecked(this.ownersChecked)
            })
          }

        } else {
          this.checkedItems = [];
          this.setChecked([]);
        };
      },
      setType(type) {
        switch (type) {
          case ('thing'): return this.$t('things.thing');
          break;
          case ('virtual'): return this.$t('things.virtual');
          break;
          case ('group'): return this.$t('things.group');
          break;
        }
      },
      async updateVirtualMerged(val, item, virtualItem) {
        /*let string = item.id;
        let virtualIds = [];
        virtualItem.included_devices.forEach(item => {
          virtualIds.push(item.id)
        });
        virtualIds = virtualIds.join(',');

        if (!!virtualIds && virtualIds != null && virtualIds != 'null') {
          string = `${virtualIds},${string}`;
        }*/
        this.draggedEl.forEach((itemDrag) => {
          let data = {
            //  access_token: this.token,
            //subdevices: string,
            device_id: itemDrag.id,
            parent_device_id: val
          };
          let formData = this.toFormData(data);
          this.updateThing(formData).catch(e => {
            if (e.message === 'error include') {
              this.showLoaderMethod(false);
              this.showOverlay(true);
              this.showErrorMerge(true)
            };
            throw new Error('stop')
          })
        })
        this.draggedEl = '';
      },
      goTo(item, flag) {
        if (!this.journalsPages && !this.journalMultithingPage) {
          if (this.isThing(item)) {
            this.$router.push('/things/thing/' + item.id)
          } else if (this.isVirtual(item)) {
            if (flag === 'multi') {
              this.$router.push('/things/thing/' + item.id)
            } else {
              this.$router.push('/things/multithing/' + item.id)
            }
          }
        } else {
          if (flag === 'multi') {
            this.$router.push('/journals/journal-' + item.id)
            return
          }
          if (this.isThing(item)) {
            return;
            // this.$router.push('/journals/journal-' + item.id)
          } else if (this.isVirtual(item)) {
            this.$router.push('/journals/multithing/' + item.id)
          }
        }
      }
    },
    mounted() {
      this.setAdminRole()

      // if (this.journalsPages || this.journalMultithingPage) {
      //   this.setLinkName('journals');
      // }
      // if (window.matchMedia('(max-width: 2400px)').matches) {
      //   this.widthName = 42
      // }
      // if (window.matchMedia('(max-width: 2000px)').matches) {
      //   this.widthName = 37
      // }
      // if (window.matchMedia('(max-width: 1750px)').matches) {
      //   this.widthName = 25
      // }
      // if (window.matchMedia('(max-width: 1680px)').matches) {
      //   this.widthName = 21
      // }
      // if (window.matchMedia('(max-width: 1440px)').matches) {
      //   this.widthName = 17
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .w14 {
    width: 14px;
  }

  .moved_class-opacity {
    display: none!important;
  }

  .hidden-element {
    position: absolute;
    cursor: move;
  }

  .things-item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 60px;
    /*border-bottom: 1px solid $grey;*/
    padding: 0px 20px;
    /*margin-top: 10px;*/
    border-radius: 6px;
    font-family: $mm;
    font-size: 13px;
    letter-spacing: .25px;
    color: $darkBlue;
    user-select: none;

    @media screen and (max-width: 1370px) {
      font-size: 12px;
    }
  }

  .things-item:not(:first-child) {
    background: rgba(215, 227, 234, .5);
    margin: 5px 0;
    &:not(.hidden-element) {
      &:hover {
        background: white;
        box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      }
    }
  }


  .things-item_checked {
    background: rgba(215, 227, 234, .5)!important;
  }

  .legend-item {
    &:hover {
      background: none;
      box-shadow: none;
    }
  }

  //970

  .cell1 {
    min-width: 26px;
  }

  .item-assigned {
    .cell2 {
      width: 260/970 * 100%;
      padding-left: 20px;
      display: flex;
      align-items: center;
      padding-right: 10px;
      cursor: pointer;

      svg {
        margin-right: 20px;
        min-width: 40px;
      }
    }

    .cell3 {
      padding: 0 10px;
      width: 120/970 * 100%;
      display: flex;
      align-items: center;
      cursor: pointer;

      svg {
        margin-right: 20px;
        min-width: 40px;
      }
    }

    .cell4 {
      padding: 0 10px;
      width: 205/970 * 100%;
      display: flex;
      align-items: center;
    }

    .cell5 {
      padding: 0 10px;
      cursor: pointer;
      width: 150/970 * 100%;
      display: flex;
      align-items: center;
      /*padding-right: 10px;*/

      svg {
        margin-right: 20px;
        min-width: 40px;
      }
    }


    .cell6 {
      width: 30px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cell-hidden {
      width: 170/970 * 100%;

    }
  }

  .legend {
    font-family: $mr;
    font-size: 13px;
    color: $darkBlue;
    opacity: .5;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;


  }


  .legend-active {
    opacity: 1;
  }

  .avatar-cont {
    min-width: 20px;
    min-height: 20px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 20px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: $grey;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      max-width: 60%;
    }
  }

  .moved_class {
    cursor: move;
    position: absolute;
    z-index: 100000;
    width: 100%;
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;
  }

  .hiddenClass {
    visibility: hidden!important;
  }

  .things-drop {
    border: 2px solid $lightBlue;
    border-radius: 8px;
  }

  .edit-btn {
    position: relative;
  }
  .project-things {
    .item-assigned .cell2 {
      padding-left: 0;
    }
  }
</style>
